import { http } from '@/http/index'

async function qrValidate(girlId, expires, hash, signature) {
	return http
		.get(`/girls/${girlId}/verifications/qr-validate?expires=${expires}&hash=${hash}&signature=${signature}`)
		.then((response) => response.data)
}

export { qrValidate }
